module.exports = __webpack_public_path__ + "img/export-csv-file.677ef0ba.webp";